module.exports = __webpack_public_path__ + "glyphicons-halflings-regular.woff";


/*****************
 ** WEBPACK FOOTER
 ** ./bower_components/bootstrap-sass/assets/fonts/bootstrap/glyphicons-halflings-regular.woff
 ** module id = 199
 ** module chunks = 1
 **/